import type { ReactNode } from 'react';

import { useFeatureFlags } from './useFeatureFlag';

/**
 * Mounts the shared feature-flags query once at app load so flags are fetched
 * eagerly and kept fresh (window focus + interval). Must live inside the
 * `QueryClientProvider`. Consumers read the same cached query via
 * `useFeatureFlag` (reactive) or `isFeatureEnabled` (imperative).
 */
export const FeatureFlagProvider = ({ children }: { children: ReactNode }) => {
  useFeatureFlags();
  return <>{children}</>;
};
